import * as process from "process";
export const DEFAULT_BACKEND_URL = process.env.REACT_APP_NODE_ENV == "development" ? "https://192.168.100.9:4000" : "https://api-v1.spiderx.io:4000" ;
